import Nouislider from 'nouislider-react';
import * as React from 'react';
import S from './PCMSlider.styles';
function formatCurrency(amount, currency = 'GBP', locale = 'en-GB') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
}
const PCMSlider = ({ activeLocation, locationOptions, onUpdate, startValue, }) => {
    const sliderInstance = React.useRef(null);
    const activeLocations = locationOptions.filter((option) => activeLocation.includes(option.value));
    const minPcm = Math.min(...locationOptions.map((x) => x.minPcm));
    const maxPcm = 5000;
    const range = {
        min: 0,
        '5%': [maxPcm * 0.2],
        '27.5%': [maxPcm * 0.4],
        '50%': [maxPcm * 0.6],
        '72.5%': [maxPcm * 0.8],
        '95%': [maxPcm],
        max: 5050,
    };
    let activeMinc = minPcm;
    if (activeLocations.length > 0) {
        activeMinc = Math.min(...activeLocations.map((x) => x.minPcm));
    }
    const activeMin = activeMinc > 1000 ? activeMinc : 1000;
    const start = [0, activeMin, startValue || maxPcm];
    const handleUpdate = (values) => {
        const closest500 = Math.round(values[2] / 500) * 500;
        sliderInstance.current.noUiSlider.setHandle(2, closest500);
        onUpdate(Math.max(activeMinc, closest500));
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.FormLabel, null, "MAXIMUM RENT PCM"),
        React.createElement(S.SliderContainer, null,
            React.createElement(Nouislider, { start: start, connect: [false, true, true, true], range: range, pips: {
                    mode: 'positions',
                    values: ['5', '27.5', '50', '72.5', '95'],
                    density: 15,
                    format: {
                        to: (value) => {
                            return formatCurrency(value);
                        },
                    },
                    filter: (value, type) => {
                        if (value < 1000 || value > 5000) {
                            return -1;
                        }
                        return type;
                    },
                    stepped: true,
                }, padding: [0, 50], onChange: handleUpdate, instanceRef: (instance) => {
                    sliderInstance.current = instance;
                    const connects = instance?.querySelectorAll('.noUi-connect');
                    const origins = instance?.querySelectorAll('.noUi-origin');
                    const classes = ['c-1-color', 'c-2-color', 'c-3-color', 'c-4-color', 'c-5-color'];
                    for (let i = 0; i < connects.length; i++) {
                        connects[i].classList.add(classes[i]);
                    }
                    for (let i = 0; i < origins.length - 1; i++) {
                        origins[i].setAttribute('disabled', 'disabled');
                    }
                } }))));
};
export default PCMSlider;
